<template>
  <div class="pb-30">
    <ContentSection
      skew="right"
      id="our-people"
      class="z-0 bg-regalblue-500"
      :class="[spotlights.length > 0 ? 'pb-16' : 'pb-48']"
    >
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-4xl text-white">Our people</h1>
          <p class="pb-2 text-xl sm:text-2xl font-light text-white">
            Together, our amazing team of dedicated and talented people have superpowers to create
            incredible solutions for our customers. Look out for our regular people spotlights to
            learn about the wonderful folks who make Pipefish tic.
          </p>
        </div>
      </div>
    </ContentSection>

    <ContentSection
      skew="right"
      id="our-people-spotlight"
      class="z-30 bg-astralblue-400 mt-0 py-12"
      v-if="spotlights.length > 0"
    >
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-3">
          <h2 class="text-xl text-white">Spotlight</h2>
        </div>
        <div class="col-span-12 sm:col-span-9">
          <div class="flex-2col">
            <div class="card-wrap pb-3 sm:pr-3" v-for="item in spotlights" v-bind:key="item.slug">
              <PeopleCard :person="item" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>

    <!-- <ContentSection id="our-people-directors" skew="right" class="z-10 bg-grey-100 my-0 pt-16">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-3">
          <h2 class="text-xl text-regalblue-500">Directors</h2>
        </div>
        <div class="col-span-12 sm:col-span-9">
          <div class="flex-2col">
            <div class="card-wrap" v-for="item in directors" v-bind:key="item.slug">
              <PeopleCard :person="item" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection> -->

    <ContentSection id="our-people-partners" skew="right" class="z-10 bg-grey-100 my-0 pt-16">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-3">
          <h2 class="text-xl text-regalblue-500">The Pipefish <br />Management Team</h2>
        </div>
        <div class="col-span-12 sm:col-span-9">
          <div class="flex-2col">
            <div class="card-wrap pb-3 sm:pr-3" v-for="item in partners" v-bind:key="item.slug">
              <PeopleCard :person="item" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>

    <ContentSection id="our-people-team" skew="right" class="z-10 bg-grey-100 my-0 pb-32 -mb-8">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-3">
          <h2 class="text-xl text-regalblue-500">The Pipefish Team</h2>
        </div>
        <div class="col-span-12 sm:col-span-9">
          <div class="flex-2col">
            <div class="card-wrap pb-3 sm:pr-3" v-for="item in team" v-bind:key="item.slug">
              <PeopleCard :person="item" />
            </div>
          </div>
        </div>
      </div>
    </ContentSection>
  </div>
</template>

<script>
/* global _ */

import ContentSection from '@/components/ContentSection.vue';
import PeopleCard from '@/components/PeopleCard.vue';

export default {
  name: 'CaseStudiesIndex',
  props: ['standalone'],
  components: {
    ContentSection,
    PeopleCard
  },
  data: function() {
    return {
      isStandalone: this.standalone,
      data: [],
      spotlights: [],
      directors: [],
      partners: [],
      team: []
    };
  },
  methods: {
    getData: function() {
      var vm = this;
      vm.data = _.sortBy(vm.Store.people, [
        function(o) {
          return o.lastName;
        }
      ]);
      this.directors = vm.data.filter(item => item.director === true);
      this.partners = vm.data.filter(item => item.partner === true);
      this.spotlights = vm.data.filter(item => item.spotlight === true);
      this.team = vm.data.filter(item => !item.director && !item.partner);
      this.ready = true;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getData();
    });
  }
};
</script>

<style lang="scss" scoped>
// @import '../styles/includes';

// @mixin caseStudyTheme($primary) {
//   .case {
//     .no {
//       color: rgba($primary, 0.3);
//     }
//     .name a,
//     .name span {
//       color: $primary;
//     }
//     &:hover {
//       background: darken($primary, 10%);
//       .no,
//       .name a,
//       .name span {
//         color: #fff;
//       }
//     }
//   }
// }

// .sect--people-intro {
//   margin: 0 0 -50px 0;
//   padding: 50px 0 150px 0;
//   background: $PriPurple;
//   transform: skewY($skew);
//   > .inner {
//     transform: skewY($-skew);
//   }
//   &.standalone {
//     margin-top: 70px;
//     padding-top: 10px;
//     margin-bottom: 80px;
//     padding-bottom: 100px;
//     .inner {
//       // margin-top: 20px;
//     }
//   }
// }

// .sect--people-spotlight {
//   margin: 0 0 -50px 0;
//   padding: 50px 0 150px 0;
//   background: $PriPurple;
//   transform: skewY($skew);
//   > .inner {
//     transform: skewY($-skew);
//   }
//   &.standalone {
//     margin-top: 70px;
//     padding-top: 10px;
//     margin-bottom: 80px;
//     padding-bottom: 100px;
//     .inner {
//       // margin-top: 20px;
//     }
//   }
// }

.work-grid-people {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: center;
  margin: 20px 0 0 0;
  // background: red;
  a.item,
  div.item {
    width: 100%;
    cursor: pointer !important;
    @include media('>500px') {
      width: 33.333333%;
    }

    .case {
      @include rtp_transition($property: 'transform', $duration: 0.3s);
      position: relative;
      margin: 3px;
      // height: auto !important;
      background: #fff;
      border-radius: 2px;
      cursor: pointer !important;
      @include media('>=450px') {
        // height: 125px;
      }
      &:hover {
        background: darken($CaseStudyBlue, 10%);
        box-shadow: 0px 2px 7px 0 rgba(102, 102, 102, 0.2);
        .no,
        .name a,
        .name span {
          color: #fff;
        }
        .name a,
        .name span {
          text-decoration: underline;
        }
      }

      .no {
        font-family: $brand-font-family;
        font-size: 50px;
        position: absolute;
        left: 0px;
        top: 0px;
        font-weight: 800;
        z-index: 10;
        color: rgba($CaseStudyBlue, 0.3);
        padding: 0 0 0 15px;
        @include media('>=medium') {
          // top: 0px;
          // left: 0px;
          padding: 5px 0 0 25px;
        }
      }
      .name {
        // @include rtp_transition($duration: 0.55s);
        // position: absolute;
        // z-index: 15;
        // top: auto;
        // right: 0;
        // bottom: 0;
        // left: 0;
        padding: 0px 10px 10px 15px;
        color: $CaseStudyBlue;
        // color: #fff !important;
        cursor: pointer;
        @include media('>=medium') {
          // top: 55px;
          padding: 10px 25px 15px 25px;
        }
        a,
        span {
          color: $CaseStudyBlue;
          font-family: $brand-font-family;
          // color: #fff !important;
          font-size: 19px;
          font-weight: 400;
          line-height: 1.2em;
          text-decoration: none;
          @include media('>500px') {
            font-size: 17px;
          }
          @include media('>=medium') {
            // font-size: 17px;
          }
          @include media('>800px') {
            font-size: 19px;
          }
          // &:hover {
          //   color: #fff;
          //   text-decoration: underline;
          // }
        }
      }
    }
  }
}
</style>
